import { alpha, type SxProps, type Theme } from "@mui/material/styles";

import type { InstagramInfoTileTone } from "./InstagramInfoTile.types";

const toneColor = (theme: Theme, tone: InstagramInfoTileTone) =>
  tone === "neutral" ? theme.palette.primary.main : theme.palette[tone].main;

export const root: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(1.25),
  p: theme.spacing(1.75),
  borderRadius: 2,
  bgcolor: "background.default",
  minWidth: 0,
});

export const iconTile =
  (tone: InstagramInfoTileTone): SxProps<Theme> =>
  (theme) => ({
    width: 36,
    height: 36,
    flex: "none",
    borderRadius: 1.25,
    bgcolor: alpha(toneColor(theme, tone), 0.1),
    color: toneColor(theme, tone),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  });

export const text: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.375),
  minWidth: 0,
  flex: 1,
});

export const label: SxProps<Theme> = {
  fontSize: "0.6875rem",
  color: "text.secondary",
  fontWeight: 600,
};

export const value: SxProps<Theme> = {
  fontSize: "0.78125rem",
  fontWeight: 700,
  lineHeight: 1.7,
};

export const action: SxProps<Theme> = (theme) => ({
  mt: theme.spacing(0.75),
});
